<template>
  <!-- NOTE (TEMPLATE) to show the active proposals -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-modal
      id="fastReviewDone"
      ref="fastReviewDone"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="lg"
    >
      <template v-slot:modal-header>
        <h4>جمع‌بندی نظرات داوران</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              :disabled="
                !myReview.respone ||
                (!myReview.eliminate && busy) ||
                !myReview.response ||
                (myReview.response == 'incomplete' && !description
                  ? true
                  : false) ||
                (myReview.response == 'rejected' && !myReview.rejectCause.length
                  ? true
                  : false)
              "
              variant="primary"
              size="lg"
              @click="fastReviewDone()"
              >جمع‌بندی</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('fastReviewDone')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <h5>نظرات داوران</h5>
      <b-table
        responsive
        small
        show-empty
        head-variant="dark"
        :items="myReview.reviews"
        :fields="reviewFields"
        empty-text="رکوردی برای نمایش وجود ندارد"
        empty-filtered-text="رکوردی برای نمایش وجود ندارد"
        class="table table-secondary my-3"
      >
        <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        <template v-slot:cell(referee)="data">
          <span v-if="data.item.isAccelerator">{{
            data.item.accelerator + " (شتاب‌دهنده)"
          }}</span>

          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(status)="data">
          {{ statusDictionary.find((x) => x.en == data.value).fa }}
        </template>
      </b-table>
      <hr v-if="myReview.reviews.isAccelerator" />
      <div v-if="computedCheckBox" class="d-flex flex-row my-4">
        <b-form-checkbox
          style="margin-right: -8px"
          v-model="myReview.eliminate"
        >
        </b-form-checkbox>
        <div class="pl-2">حذف تجاری سازی</div>
      </div>
      <div v-if="!myReview.eliminate">
        <h5>نظر نهایی</h5>
        <b-form-select
          class="my-1"
          :options="reviewResponses"
          v-model="myReview.response"
        />
        <b-form-group
          class="my-1"
          v-if="myReview.response == 'rejected'"
          label="دلایل رد"
        >
          <v-select
            multiple
            :reduce="(x) => x.code"
            :options="rejectOptions"
            style="direction: ltr"
            v-model="myReview.rejectCause"
            class="reject-select"
          >
          </v-select>
        </b-form-group>
      </div>
      <b-form-group
        v-if="myReview.response == 'incomplete'"
        class="my-1"
        label="توضیحات *"
      >
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="description"
          v-model="description"
          width="75%"
          placeholder="توضیحات خود را اینجا وارد نمایید"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group v-else class="my-1" label="توضیحات">
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="description"
          v-model="description"
          width="75%"
          placeholder="توضیحات خود را اینجا وارد نمایید"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
    <b-card
      v-if="$router.currentRoute.path == '/admin/todo/reviewDone'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <p>
        ادمین گرامی؛
        <br />
        حمایت‌های در حال داوری که کلیه داوران آن را داوری کرده‌اند در این بخش
        نمایش داده میشود.
        <br />
        شما میتوانید روی نام هر حمایت کلیک کنید و وارد جزییات آن شوید. همچنین
        میتوانید با کلیک روی گزینه جمع‌بندی نظرات داوران، داوری را محتومه و نظر
        نهایی خود را (پذیرش / رد / نیاز به اصلاح) ثبت کنید.
      </p>
      <h6>
        <hr />
        <b-button
          @click="
            selectedType = 'all';
            currentPage = 1;
          "
          :variant="selectedType == 'all' ? 'primary' : 'outline-primary'"
          class="m-1"
          >همه ({{ items.length }})</b-button
        >
        <b-button
          v-for="type in types"
          :key="type.key"
          @click="
            selectedType = type.key;
            currentPage = 1;
          "
          :disabled="!items.filter((x) => x.requestType == type.key).length"
          :variant="selectedType == type.key ? 'primary' : 'outline-primary'"
          class="m-1"
          >{{ type.title }} ({{
            items.filter((x) => x.requestType == type.key).length
          }})</b-button
        >
        <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 25px 1px">
          <v-col>
            <h4 style="margin-top: 9px">
              {{ selectedType == "all" ? "همه درخواست‌ها" : selectedType }}
            </h4>
          </v-col>
          <v-col>
            <v-btn
              class="bc-primary text-white btn-radius float-end"
              width="200"
              height="45"
              elevation="0"
              :disabled="isBusy || !computedItems.length"
              @click="$refs.table1.$el.click()"
            >
              <span class="fs-small">
                خروجی اکسل

                <v-icon>$Excel</v-icon></span
              >
            </v-btn>
            <vue-excel-xlsx
              v-show="false"
              ref="table1"
              :data="computedItems"
              :columns="excelFields"
              :filename="
                'لیست حمایت های داوری شده (' +
                (selectedType == 'all' ? 'همه درخواست‌ ها' : selectedType) +
                ')'
              "
              :sheetname="currentDate"
            >
              دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            class="mt-1"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-activeProposals) to show the active proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="رکوردی برای نمایش وجود ندارد"
        empty-filtered-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(time)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.item.last_update }}
          </div>
        </template>
        <template v-slot:cell(faSubject)="data">
          <div style="text-align: center; vertical-align: middle">
            <a
              v-if="data.item.requestTypeEn == 'project'"
              :href="'/admin/proposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'phd'"
              :href="'/admin/phdProposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'master'"
              :href="'/admin/masterProposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'opportune'"
              :href="'/admin/opportunity/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'elite'"
              :href="'/admin/elite/' + data.item.id"
              target="_blank"
              >نخبه وظیفه</a
            >
            <a
              v-else
              :href="'/admin/' + data.item.requestTypeEn + '/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <b-button
              variant="success"
              @click="openReviewDoneModal(data.item)"
              class="m-2 text-light"
              >جمع‌بندی نظرات داوران</b-button
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="selectedType == 'all' ? totalRows : computedItems.length"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  components: {},
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "faSubject", label: "عنوان حمایت" },
        { key: "researcherName", label: "نام پژوهشگر" },
        { key: "requestType", label: "نوع حمایت" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "university", label: "دانشگاه" },
        { key: "judgeStatus", label: "وضعیت داوری" },
        { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی", sortable: true },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "faSubject", label: "عنوان حمایت" },
        { field: "researcherName", label: "نام پژوهشگر" },
        { field: "requestType", label: "نوع حمایت" },
        { field: "requestsCode", label: "کد طرح" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "university", label: "دانشگاه" },
        { field: "judgeStatus", label: "وضعیت داوری" },
        { field: "version", label: "نسخه" },
        { field: "lastUpdate", label: "آخرین بروزرسانی", sortable: true },
      ],
      types: [
        { key: "طرح پژوهشی", title: "طرح" },
        { key: "رساله دکتری", title: "رساله دکتری" },
        { key: "پایان نامه کارشناسی ارشد", title: "پایان‌نامه ارشد" },
        { key: "مقاله", title: "مقاله" },
        { key: "فرصت مطالعاتی", title: "فرصت مطالعاتی" },
        { key: "نشست تخصصی", title: "نشست تخصصی" },
        { key: "پسادکتری", title: "پسادکتری" },
        { key: "نخبگان وظیفه", title: "نخبگان وظیفه" },
      ],
      items: [],
      filter: "",
      selectedType: "all",
      isBusy: true,
      busy: false,
      description: "",
      selectedRequest: {},
      rejectCause: [],
      myReview: {
        reviews: [],
        response: null,
        rejectCause: [],
      },
      reviewResponses: [
        { value: "initialAccept", text: "مورد تایید است" },
        {
          value: "incomplete",
          text: "نیازمند اصلاحات و داوری مجدد",
        },
        { value: "rejected", text: "مورد تایید نیست" },
      ],
      reviewFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
      ],
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectOptions: [],
    };
  },

  methods: {
    rejections() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = [];
          this.rejectOptions.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openReviewDoneModal(item) {
      this.selectedRequest = item;
      this.description = "";

      this.myReview = {
        reviews: [],
        response: null,
        rejectCause: [],
      };

      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/showReviews",
          {
            requestId: this.selectedRequest.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.myReview.reviews = res.data;
          this.showModal("fastReviewDone");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    fastReviewDone() {
      this.busy = true;
      if (!this.myReview.eliminate) {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/reviewDone",
            {
              requestId: this.selectedRequest.id,
              status: this.myReview.response,
              rejectionIds:
                this.myReview.response == "rejected"
                  ? this.myReview.rejectCause
                  : [],
              description: this.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.busy = false;
            this.hideModal("fastReviewDone");
            this.onMounted();
          })
          .catch((err) => {
            this.busy = false;
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403) {
              if (err.response.data == "expired")
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
              else
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
            }
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/removeCommercializing",
            {
              requestId: this.selectedRequest.id,
              description: this.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.busy = false;
            this.hideModal("fastReviewDone");
            this.onMounted();
          })
          .catch((err) => {
            this.busy = false;
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403) {
              if (err.response.data == "expired")
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
              else
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
            }
          });
      }
    },
    hideModal(id) {
      // NOTE (m-hideModal) to hide modal
      this.$refs[id].hide();
    },
    showModal(id) {
      // NOTE (m-showModal) to show modal
      this.$refs[id].show();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      this.isBusy = true;
      // NOTE (MOUNTED) to show the proposals data
      this.$http
        .post(
          this.baseUrl + "/setad/admin/requests/reviewDone",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  computed: {
    computedItems() {
      let filtered = [];
      if (this.selectedType != "all") {
        filtered = this.items.filter((x) => x.requestType == this.selectedType);
      } else {
        filtered = this.items;
      }
      return filtered;
    },
    computedCheckBox() {
      if (
        this.selectedRequest.requestTypeEn == "project" ||
        this.selectedRequest.requestTypeEn == "phd" ||
        this.selectedRequest.requestTypeEn == "master" ||
        this.selectedRequest.requestTypeEn == "opportune" ||
        this.selectedRequest.requestTypeEn == "postDoc"
      ) {
        return true;
      } else return false;
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/todo/reviewDone")
      this.onMounted();
    this.rejections();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
.reject-select {
  .vs__dropdown-menu {
    direction: rtl !important;
  }
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

</style>
